import RightBar from "./right-bar";
import UserProfile from "./user-profile";

const UserPage = () => {
    return (
        <div className='min-h-screen w-full bg-gray-100'>
            <div className="sm:p-4 mx-2">
                <div className="flex flex-wrap justify-center gap-4">
                    {/* User Profile */}
                    <UserProfile />

                    {/* Right Sidebar */}
                    <RightBar />
                </div>
            </div>
        </div>
    );
};

export default UserPage;